import React from 'react'
import PageHeader from '../components/PageHeader'

const RTI_Committee = () => {
    return (
        <div>
            <PageHeader title="Right to Education" />
        </div>
    )
}

export default RTI_Committee